import { useAtomValue } from 'jotai';
import { Routes } from 'src/Routes.constants';
import { mapESimFiltersToURLSearchParams } from '../Inventory/Filters/SearchParams/constants/esimSearchParams';
import { esimFiltersAtom } from 'src/atoms/filters/esim-products';

export const useESimProductUrlFromFilters = () => {
  const filters = useAtomValue(esimFiltersAtom);
  return `${Routes.esim}?${mapESimFiltersToURLSearchParams(filters)}`;
};
